<template>
  <div class=''>
    <div class="no-content">
      <img :src="backgroundImage" alt="">
      <p>{{this.$store.state.status.blank_text}}</p>
    </div>
  </div>
</template>

<script>
	import contentImg from '../utils/image'
export default {
  data() {
    return {
      backgroundImage:''
    }
  },
  created(){
    const randIndex = Math.floor(Math.random() * contentImg.length)
    this.backgroundImage= contentImg[randIndex]
  }
}
</script>

<style scoped lang='less'>
.no-content{
  width: 100%;
  height: 500px;
	margin: 30px auto;
  background-color: #FFFFFF;
  border-radius: 6px;
  text-align: center;
  overflow: hidden;
  img{
    width: 119px;
    height: 128px;
    margin: 107px auto 45px;
  }
  p{
    color: #666666;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/blank.vue